export const GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS =
  'GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS';
export const GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS_START = `${GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS}_START`;
export const GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS_SUCCESS = `${GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS}_SUCCESS`;
export const GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS_FAIL = `${GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS}_FAIL`;

export const GET_SUBSCRIBERS = 'GET_SUBSCRIBERS';
export const GET_SUBSCRIBERS_START = `${GET_SUBSCRIBERS}_START`;
export const GET_SUBSCRIBERS_SUCCESS = `${GET_SUBSCRIBERS}_SUCCESS`;
export const GET_SUBSCRIBERS_FAIL = `${GET_SUBSCRIBERS}_FAIL`;

export const GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS =
  'GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS';
export const GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_START = `${GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS}_START`;
export const GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_SUCCESS = `${GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS}_SUCCESS`;
export const GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_FAIL = `${GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS}_FAIL`;

export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION';

export const GET_SUBSCRIPTION_FORM = 'GET_SUBSCRIPTION_FORM';
export const GET_SUBSCRIPTION_FORM_START = `${GET_SUBSCRIPTION_FORM}_START`;
export const GET_SUBSCRIPTION_FORM_SUCCESS = `${GET_SUBSCRIPTION_FORM}_SUCCESS`;
export const GET_SUBSCRIPTION_FORM_FAIL = `${GET_SUBSCRIPTION_FORM}_FAIL`;

export const POST_SUBSCRIPTION_FORM = 'POST_SUBSCRIPTION_FORM';
export const POST_SUBSCRIPTION_FORM_START = `${POST_SUBSCRIPTION_FORM}_START`;
export const POST_SUBSCRIPTION_FORM_SUCCESS = `${POST_SUBSCRIPTION_FORM}_SUCCESS`;
export const POST_SUBSCRIPTION_FORM_FAIL = `${POST_SUBSCRIPTION_FORM}_FAIL`;

/**
 * !!! do not use on it's own if you need the subscribers list !!!
 * Fetch just the UserSubscription object (with only first 100 subscribers included)
 * @param {string} subscriptionId
 */
const getJustSubscription = subscriptionId => ({
  type: GET_SUBSCRIPTION_WITHOUT_SUBSCRIBERS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/subscriptions/${subscriptionId}`,
    method: 'get',
  },
  payload: {},
});

/**
 * Fetch all subscribers for a UserSubscription
 * @param {string} subscriptionId
 */
const getAllSubscribers = subscriptionId => ({
  type: GET_SUBSCRIBERS,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/subscriptions/${subscriptionId}/subscribers`,
    method: 'getallwithembeds',
    params: {
      limit: 1000,
    },
  },
  payload: {},
});

/**
 * Fetch UserSubscription details with full list of recipients
 * @param {string} subscriptionId
 */
export const getSubscription = subscriptionId => dispatch => {
  dispatch({ type: GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_START });
  // because the xm-api subscriptions/{subscriptionId} endpoint will only return
  // the first 100 subscribers, we need to do a separate call
  // to get the full subscribers list
  Promise.all([
    dispatch(getJustSubscription(subscriptionId)),
    dispatch(getAllSubscribers(subscriptionId)),
  ]).then(
    ([subscriptionResponse, subscribersResponse]) => {
      const subscription = subscriptionResponse.payload;
      dispatch({
        type: GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_SUCCESS,
        payload: {
          ...subscription,
          recipients: subscribersResponse.payload,
        },
      });
    },
    () => {
      dispatch({ type: GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_FAIL });
    },
  );
};

/**
 * Clear subscription from state
 * @param {string} subscriptionId
 */
export const clearSubscription = subscriptionId => ({
  type: CLEAR_SUBSCRIPTION,
  payload: { subscriptionId },
});

/**
 * Fetch SubscriptionForm by SubscriptionForm id or name
 * @param {string} subscriptionDomainId the subscription form or name
 */
export const getSubscriptionForm = subscriptionDomainId => ({
  type: GET_SUBSCRIPTION_FORM,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/subscription-forms/${subscriptionDomainId}?embed=propertyDefinitions`,
    method: 'get',
    isUriEncoded: true,
  },
  payload: {},
});

/**
 * Save UserSubscription details
 * @param {UserSubscription} params
 */
export const saveUserSubscription = params => ({
  type: POST_SUBSCRIPTION_FORM,
  meta: {
    xmWebApp: true,
    uri: '/webapi/xm/1/subscriptions',
    method: 'post',
    params,
  },
});
